<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="
      t('common.paramStatuses', {
        param: t('shipments.financials.shipmentFinancials'),
      })
    "
    class="shipment-financial-status-filter w-2"
    optional
  >
    <FinancialStatusMultiSelect
      :id="inputId"
      v-model="internalValue.financialStatuses"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';

import { ShipmentSearchCriteria } from '@/model';

import FinancialStatusMultiSelect from '@/components/shipment/FinancialStatusMultiSelect.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: ShipmentSearchCriteria,
    default: () => new ShipmentSearchCriteria(),
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: ShipmentSearchCriteria): void;
}>();
const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<ShipmentSearchCriteria>) =>
    new ShipmentSearchCriteria(opts),
});
</script>
